import { Suspense, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { ErrorBoundary } from "./ErrorBoundary";

export function PageLoader() {
  return (
    <div className="flex h-full items-center justify-center">
      <div
        className="h-6 w-6 animate-spin rounded-full border-2 border-primary border-t-transparent"
        role="status"
        aria-label="Loading page"
      />
    </div>
  );
}

export function RoutePage({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return (
    <Suspense fallback={<PageLoader />}>
      <ErrorBoundary resetKey={pathname}>{children}</ErrorBoundary>
    </Suspense>
  );
}
